module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "top-up-result-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: [{
      'pay-failed-box': !_vm.loading && _vm.orderInfo.state !== 'paid'
    }, 'modal-dialog'],
    attrs: {
      "role": "document"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "modal-content loading"
  }, [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? [(_vm.orderInfo.state === 'paid') ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "pay-success"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/success_2x.png",
      "alt": " "
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('paid')))]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('price')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.orderInfo.order_detail.currency_symbol)) + " " + _vm._s(_vm.orderInfo.order_detail.total_amount))])]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('deviceNum')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.orderInfo.max_device_count) + " " + _vm._s(_vm.$tc('devices', _vm.orderInfo.max_device_count)))])]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('packageTime')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.orderInfo.value_of_expire_in) + " " + _vm._s(_vm.$tc(_vm.orderInfo.unit_of_expire_in, _vm.orderInfo.value_of_expire_in)))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.gtmEvent('payment_success')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))])])], 1) : _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "pay-failed"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/failure_2x.png",
      "alt": " "
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('payFailed')))]), _vm._v(" "), (_vm.errorNotice) ? _c('p', [_vm._v(_vm._s(_vm.errorNotice))]) : _c('p', [_vm._v(_vm._s(_vm.$t('failedNotice')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.gtmEvent('payment_fail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('contactUs')))]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v("iplexservice@gmail.com")])])], 1)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6c0e0f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topup/topUpResult/TopUpResult.vue
// module id = 1382
// module chunks = 1